import React from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { RefreshCw } from 'lucide-react';
import { generateVerificationToken } from '../../utils/tokenUtils';

interface TokenGeneratorProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    helpText?: string;
    required?: boolean;
    isInvalid?: boolean;
    errorMessage?: string;
}

/**
 * Token Generator Component
 * Input field with a "Generate" button to create secure random tokens
 */
const TokenGenerator: React.FC<TokenGeneratorProps> = ({
    value,
    onChange,
    label,
    helpText,
    required = false,
    isInvalid = false,
    errorMessage
}) => {
    const handleGenerate = () => {
        const token = generateVerificationToken();
        onChange(token);
    };

    return (
        <Form.Group className="mb-3">
            <Form.Label>
                {label}
                {required && <span className="text-danger"> *</span>}
            </Form.Label>
            <InputGroup>
                <Form.Control
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    required={required}
                    isInvalid={isInvalid}
                    placeholder="Token de verificação"
                />
                <Button 
                    variant="outline-secondary" 
                    onClick={handleGenerate}
                    title="Gerar token aleatório"
                >
                    <RefreshCw size={18} /> Gerar
                </Button>
                {isInvalid && errorMessage && (
                    <Form.Control.Feedback type="invalid">
                        {errorMessage}
                    </Form.Control.Feedback>
                )}
            </InputGroup>
            {helpText && !isInvalid && (
                <Form.Text className="text-muted">
                    {helpText}
                </Form.Text>
            )}
        </Form.Group>
    );
};

export default TokenGenerator;
